export class EmergencyAccessAcceptRequest {
  token: string;
}
